import React from 'react';
import { useIntl } from 'react-intl';
import { useLocalStorage } from 'react-use';

import LocalizedMonetaryAmount from 'modules/payout-reports/LocalizedMonetaryAmount';
import { useGetOfferByMerchantID } from 'modules/wolt-capital/useGetOfferByMerchantID';

import { NavigationItem } from './types';

const useWoltCapitalTooltip = (merchantId: string) => {
  const [isWoltCapitalPopoverVisible, setIsWoltCapitalPopoverVisible] = useLocalStorage('wolt-capital-popover', 'true');
  const intl = useIntl();

  const showWoltCapitalPopover = isWoltCapitalPopoverVisible === 'true';

  const t = (id: string, offerAmount: string | React.JSX.Element) => intl.formatMessage({ id }, { offerAmount });
  const { hasOngoingOffer, merchantOfferCurrency: currency, merchantOfferAmount } = useGetOfferByMerchantID(merchantId);

  const isTooltipEnabled = showWoltCapitalPopover && hasOngoingOffer && currency && merchantOfferAmount;

  const dismiss = () => setIsWoltCapitalPopoverVisible('false');

  const offerAmount = isTooltipEnabled ? (
    <LocalizedMonetaryAmount
      amount={merchantOfferAmount}
      currency={currency as Currency}
      numberFormatOptions={{ minimumFractionDigits: 0 }}
    />
  ) : undefined;

  const tooltip = offerAmount
    ? { text: t('wolt-capital.popover.text', offerAmount), id: 'WOLT_CAPITAL' as NavigationItem, dismiss }
    : undefined;

  return { tooltip };
};

export default useWoltCapitalTooltip;
